<template>
    <v-card class="mt-4" flat>
        <v-card-text>
            <h2 class="primary--text text--darken-3 ">No Interest Buyers</h2>
            <div class="d-flex mx-1 my-4 py-2" style="width:40%">
                <v-select 
                    v-model="selectedDays"
                    :items="days_before_now"
                    hide-details 
                    class="d-inline"
                    label="Select Days Back">
                </v-select>
                <v-btn
                    outlined
                    color="primary darken-1"
                    hide-details
                    class="mt-3 ml-3 d-inline"
                    @click="getNoInterestBuyers()">
                    Search
                </v-btn>
                <v-btn
                    v-if="noInterestBuyers.length"
                    color="primary darken-1"
                    hide-details
                    class="mt-3 ml-4 d-inline"
                    :loading="exporting"
                    @click="exportNoInterestBuyers()">
                    Export
                </v-btn>
            </div>
            <v-data-table
                :headers="buyers_header"
                :items="noInterestBuyers"
                item-key="buyer_id"
                class="elevation-0 buyers_table"
                style="border-top: 1px solid #D9D9D9"
                fixed-header
                :height="noInterestBuyers.length ? '60vh' : '10vh'"
                loader-height="6"
                calculate-widths
                sort-by="last_name"
                :items-per-page="-1"
                :loading="show_loader"
                loading-text="Loading... Please wait"
                @click:row="openDetailsNewTab">
               
                <template v-slot:[`item.first_name`]="{ item }">
                    <td>{{ item.first_name }}</td>
                </template>

                <template v-slot:[`item.last_name`]="{ item }">
                    <td>{{ item.last_name }}</td>
                </template>
                <template v-slot:[`item.email`]="{ item }">
                    <td>{{ item.email }}</td>
                </template>
                <template v-slot:[`item.phone`]="{ item }">
                    <td>{{ item.phone }}</td>
                </template>
                <template v-slot:[`item.state`]="{ item }">
                    <td>{{ item.state }}</td>
                </template>
                <template v-slot:[`item.date_initialized`]="{ item }">
                    <td>{{ item.date_initialized_text }}</td>
                </template>
                <template v-slot:[`item.modules`]="{ item }">
                    <td v-html="item.modules_text"></td>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>


<script>
    import axios from 'axios';
    import Cookie from 'js-cookie';
    import { saveAs } from 'file-saver';
    import dateformat from 'dateformat'

    import appUrls from '../../helpers/environment';
    import { formatPhoneNumber } from '../../helpers/utilities'
    import { capitalizeFirstWord } from '../utilities'

    export default {
        name: 'NoInterestBuyers',

        props: {
            triggerUserFeedback: Function
        },

        data: () => ({
            selectedDays: 10,
            noInterestBuyers: [],
            show_loader: false,
            exporting: false,
            days_before_now: [
                { value: 7,  text: '7 Days' },
                { value: 15, text: '15 Days' },
                { value: 30, text: '30 Days' },
                { value: 60, text: '60 Days' },
                { value: 90, text: '90 Days' },
            ],
            buyers_header: [
                { text: 'First Name',       value: 'first_name',       align: 'left',  sortable: true },
                { text: 'Last Name',        value: 'last_name',        align: 'left',  sortable: true },
                { text: 'Email',            value: 'email',            align: 'left',  sortable: true },
                { text: 'Phone',            value: 'phone',            align: 'left',  sortable: true },
                { text: 'State',            value: 'state',            align: 'left',  sortable: true },
                { text: 'Date Joined',      value: 'date_initialized', align: 'left',  sortable: true },
                { text: 'Other Modules',    value: 'modules',          align: 'left',  sortable: true },
                // { text: 'Exported',      value: 'buyer_exported',  align: 'start',  sortable: true },
            ]
        }),

        watch: {
            show_loader (val) {
                if ( val ) {
                    setTimeout(() => { 
                        this.show_loader = false 
                    }, 6000)
                }
            },
        },

        mounted () {
            //this.getNoInterestBuyers()
        },

        methods: {
            getNoInterestBuyers: async function () {
                this.show_loader = true
                this.noInterestBuyers = []
                
                try { 
                    const no_interest_buyers = await axios.get(`${appUrls.api}/api/admin/nudge_buyers/${this.selectedDays}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    })
                    
                    if ( no_interest_buyers.data.outcome ){
                        if ( no_interest_buyers.data.count ) {
                            this.noInterestBuyers = no_interest_buyers.data.buyers

                            for (let b in this.noInterestBuyers) {
                                this.noInterestBuyers[b].date_initialized_text = this.formatDate(this.noInterestBuyers[b].date_initialized.substr(0,10), 2);
                                this.noInterestBuyers[b].date_initialized = Date.parse(this.noInterestBuyers[b].date_initialized.substr(0,10));
                                this.noInterestBuyers[b].phone = formatPhoneNumber(this.noInterestBuyers[b].phone);
                                this.noInterestBuyers[b].state = this.noInterestBuyers[b].state;
                                let modules_text = this.noInterestBuyers[b].modules.length ? this.noInterestBuyers[b].modules.join(', ') : ''
                                if ( modules_text != '' ) {
                                    modules_text = capitalizeFirstWord(modules_text.replace(/-/g, ' '), 'each')
                                    const formatted_modules_text = modules_text.split(', ')
                                    modules_text = formatted_modules_text.join(', ').replace(/, /g, '<br>')
                                }
                                this.noInterestBuyers[b].modules_text = modules_text
                            }

                            this.show_loader = false;
                            this.$emit('triggerUserFeedback', true, no_interest_buyers.data.message)
                        } else {
                            this.noInterestBuyers = []
                            
                            setTimeout(() => {
                                this.show_loader = false
                                this.$emit('triggerUserFeedback', true, no_interest_buyers.data.message, 'accent')
                            }, 3000)
                        }
                    } else {
                        this.noInterestBuyers = []
                        this.$emit('triggerUserFeedback', true, 'There was a problem searching for no-interest buyers', 'accent')
                    }
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            exportNoInterestBuyers: async function () {
                this.exporting = true

                try {
                    const no_interest_buyers = await axios.get(`${appUrls.api}/api/admin/nudge_buyers/${this.selectedDays}/export`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    })

                    if ( no_interest_buyers.data.outcome && no_interest_buyers.data.buf ) {
                        const this_fileExt = '.xlsx';
                        const this_fileDate = this.createDateString();
                        const this_fileData = new Buffer(no_interest_buyers.data.buf, 'base64');
                        const this_fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                        const this_fileName = 'nointerestbuyer-export_'+this_fileDate+this_fileExt;

                        const this_blob = new Blob([this_fileData], {type: this_fileType});
                        saveAs(this_blob, this_fileName);
                    } else {
                        this.$emit('triggerUserFeedback', true, 'There was a problem exporting no-interest buyers', 'accent')
                    }
                } catch ( error ) {
                    console.log(error);
                    this.$emit('triggerUserFeedback', true, 'There was a problem exporting no-interest buyers', 'accent')
                } finally {
                    this.exporting = false
                }
            },

            formatDate (date, digits_of_year=4) {
                if (!date) return null;

                const [year, month, day] = date.split('-');
                return `${month}/${day}/${digits_of_year == 2 ? year.substr(2,2) : year}`;
            },

            createDateString (date=false) {
                const d         = date ? new Date (date) : new Date()
                const year      = String(d.getFullYear())
                const month     = String(d.getMonth()+1).padStart(2, '0')
                const day       = String(d.getDate()).padStart(2, '0')
                const secs      = String(d.getSeconds())
                const msec      = String(d.getMilliseconds())
                return year.concat('', month.concat('', day.concat('', secs.concat('', msec))));
            },

            openDetailsNewTab ( item ) {
                let route = this.$router.resolve({ path: `/user_details/${item.buyer_id}`});
                window.open(route.href, '_blank');
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .buyers_table >>> td {
        padding-top: .25em;
        padding-bottom: .1em;
        padding-left: 0; /* .15em */
        padding-right: 0;
        vertical-align: top;
        font-size: .9em;
    }
 >>> tbody tr {
        cursor: pointer !important;
    }
    .buyers_table >>> th {
        padding-left: 0 !important; /* .15em */
        padding-right: 0 !important;
        font-size: .9em !important;
        background-color: #eef7f8 !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/reports/NoInterestBuyers.vue